import { IThumbnail, Meta } from "../types";

// Content is bundled with the site (public/data/videos.json) — no external API.
let cache: Promise<IVideoList> | null = null;
const loadVideos = (): Promise<IVideoList> => {
  if (!cache) {
    cache = fetch("/data/videos.json").then((r) => {
      if (!r.ok) throw new Error("videos.json failed to load");
      return r.json();
    });
  }
  return cache;
};

export const apiGetVideoList = (): Promise<IVideoList> => loadVideos();

export const apiGetSingleVideo = (video_slug: string): Promise<IVideoList> => {
  return loadVideos().then((all) => {
    const exact = all.data.filter((v) => v.attributes.video_slug === video_slug);
    // fall back to case-insensitive match so legacy links with different casing still resolve
    const match = exact.length ? exact : all.data.filter((v) => v.attributes.video_slug.toLowerCase() === video_slug.toLowerCase());
    if (!match.length) return Promise.reject(new Error("not found"));
    return { data: match, meta: all.meta };
  });
};

export interface IVideoList {
  data: IVideo[];
  meta: Meta;
}

export interface IVideo {
  id: number;
  attributes: Attributes;
}

export interface Attributes {
  title: string;
  video_slug: string;
  credits: string;
  refrences: string;
  video_id: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  thumb_url: IThumbnail;
}
